import { h, Component, Element, Prop } from '@stencil/core';


@Component({
  tag: 'tip-legend'
})
export class Legend {
  @Element() el: HTMLElement;

  @Prop() options: any[];
  @Prop() revision: number = 1;

  closeModal() {
    this.el.closest('ion-modal').dismiss();
  }

  render() {
    let items = this.options.map((option) => {
      return (
        <gl-legend-item styleId="tip"
            layers={option.layers}
            image={(option.image) ?
              `${option.image}?rev=${this.revision}` : null}
            toggle={option.image === null}
            widget={(option.layers.length) ? 'divider' : 'item'}>
          {option.label}
        </gl-legend-item>
      );
    });

    return ([
      <ion-header>
        <ion-toolbar>
          <ion-title>Legend</ion-title>
          <ion-buttons slot="end">
            <ion-button title="Close legend" onClick={() => this.closeModal()}>
              <ion-icon slot="icon-only" name="close" />
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>,
      <ion-content>
        <gl-legend>
          {items}
        </gl-legend>
      </ion-content>
    ]);
  }
}
